import LoadingComponent from '@/pages/components/loadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/myVehicle/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/myVehicle',
    meta: {
      title: '交通工具'
    }
  }
]
